/*
 * Dolce Vita Smart Search
 * Turkish-aware parsing, conservative typo correction and Shopify Storefront Search.
 * The normal Shopify form stays available as the fail-safe.
 * Set window.DV_SMART_SEARCH_DISABLED = true before load for an instant kill switch.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.DVSmartSearch = api;
    if (root.document && !root.DV_SMART_SEARCH_DISABLED) api.boot(root);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var API_VERSION = '2026-07';
  var MIN_QUERY_LENGTH = 3;
  var DEBOUNCE_MS = 220;
  var CACHE_TTL_MS = 60000;
  var MAX_CACHE_ENTRIES = 50;
  var RESULT_LIMIT = 8;
  var REVIEW_API = 'https://dolcevita-massimo.ngrok.io/api/dv-yorum/ozetler';
  var BRAND_VENDOR = 'Dolce Vita Halı';
  var QUALITY_NAMES = [
    'Paradiso Plus', 'Paradiso', 'Tokyo', 'Monza', 'Puffy', 'Garda',
    'Record', 'Bohem', 'Opera', 'Jakarta', 'Perfecto'
  ];
  var FACETS = {
    color: {
      key: 'renk', label: 'Renk',
      values: {
        Beyaz: ['beyaz', 'white'], Krem: ['krem', 'ekru'], Bej: ['bej', 'beige'],
        Gri: ['gri', 'gray', 'grey'], Antrasit: ['antrasit', 'füme', 'fume'],
        Siyah: ['siyah', 'black'], Mavi: ['mavi', 'lacivert'],
        Kırmızı: ['kırmızı', 'kirmizi', 'bordo'], Kahve: ['kahve', 'kahverengi'],
        Multi: ['multi', 'çok renkli', 'cok renkli']
      }
    },
    room: {
      key: 'kullan_m_alanlar_', label: 'Kullanım alanı',
      values: {
        Mutfak: ['mutfak'], Salon: ['salon', 'oturma odası', 'oturma odasi'],
        'Yatak Odası': ['yatak odası', 'yatak odasi'],
        'Çocuk Odası': ['çocuk odası', 'cocuk odasi', 'çocuk', 'cocuk'],
        Yazlık: ['yazlık', 'yazlik']
      }
    },
    shape: {
      key: 'hal_ekli', label: 'Şekil',
      values: {
        Oval: ['oval'], Yuvarlak: ['yuvarlak', 'daire', 'dairesel'],
        Dikdörtgen: ['dikdörtgen', 'dikdortgen'], Kare: ['kare']
      }
    }
  };
  var STOP_WORDS = {
    hali: true, halisi: true, urun: true, urunler: true,
    model: true, modelleri: true, icin: true, olan: true
  };
  var SEARCH_QUERY = [
    'query DolceVitaSmartSearch($query: String!, $first: Int!, $filters: [ProductFilter!]) {',
    '  search(query: $query, first: $first, types: [PRODUCT], unavailableProducts: LAST, productFilters: $filters) {',
    '    totalCount',
    '    edges { node {',
    '      ... on Product {',
    '        id title handle vendor availableForSale tags',
    '        featuredImage { url(transform: {maxWidth: 180, maxHeight: 180}) altText width height }',
    '        priceRange { minVariantPrice { amount currencyCode } }',
    '        compareAtPriceRange { minVariantPrice { amount currencyCode } }',
    '      }',
    '    } }',
    '  }',
    '}'
  ].join('\n');

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i').replace(/ğ/g, 'g').replace(/ü/g, 'u')
      .replace(/ş/g, 's').replace(/ö/g, 'o').replace(/ç/g, 'c')
      .replace(/[×*]/g, 'x')
      .replace(/[^a-z0-9x]+/g, ' ')
      .replace(/(\d)\s*x\s*(\d)/g, '$1x$2')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function reviewSummary(product) {
    var custom = product && product.dvReview;
    var rating = Number(custom && custom.rating);
    var count = Number(custom && custom.count);
    if (!(rating > 0 && count > 0)) {
      var ratingValue = product && product.reviewRating && product.reviewRating.value;
      try {
        var parsed = typeof ratingValue === 'string' ? JSON.parse(ratingValue) : ratingValue;
        rating = Number(parsed && parsed.value != null ? parsed.value : ratingValue);
      } catch (_) { rating = Number(ratingValue); }
      count = Number(product && product.reviewCount && product.reviewCount.value);
    }
    if (!(rating > 0 && rating <= 5 && count > 0)) return { rating: 0, count: 0, photos: 0 };
    return {
      rating: Math.round(rating * 10) / 10,
      count: Math.max(0, Math.round(count)),
      photos: Math.max(0, Number(custom && custom.photos) || 0)
    };
  }

  function levenshtein(a, b) {
    a = normalize(a); b = normalize(b);
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    var prev = new Array(b.length + 1);
    var curr = new Array(b.length + 1);
    var i; var j;
    for (j = 0; j <= b.length; j += 1) prev[j] = j;
    for (i = 1; i <= a.length; i += 1) {
      curr[0] = i;
      for (j = 1; j <= b.length; j += 1) {
        curr[j] = Math.min(
          curr[j - 1] + 1,
          prev[j] + 1,
          prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)
        );
      }
      var swap = prev; prev = curr; curr = swap;
    }
    return prev[b.length];
  }

  function findQualityCorrection(token, qualityNames) {
    var source = normalize(token);
    if (source.length < 5 || /\d/.test(source)) return null;
    var candidates = (qualityNames || QUALITY_NAMES).map(function (name) {
      return { name: name, normalized: normalize(name), distance: levenshtein(source, name) };
    }).filter(function (item) {
      var maxDistance = item.normalized.length >= 8 ? 2 : 1;
      return item.distance <= maxDistance;
    }).sort(function (a, b) { return a.distance - b.distance; });
    if (!candidates.length) return null;
    if (candidates[1] && candidates[0].distance === candidates[1].distance) return null;
    return candidates[0];
  }

  function findQualityPrefix(token, qualityNames) {
    var source = normalize(token);
    if (source.length < MIN_QUERY_LENGTH || /\d/.test(source)) return null;
    var candidates = (qualityNames || QUALITY_NAMES).filter(function (name) {
      return normalize(name).indexOf(source) === 0;
    });
    if (candidates.length !== 1 || normalize(candidates[0]) === source) return null;
    return { from: token, to: candidates[0] };
  }

  function replacePhrase(text, phrase) {
    var words = normalize(phrase).split(' ').filter(Boolean);
    if (!words.length) return text;
    var pattern = words.map(function (word) {
      return word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }).join('\\s+');
    return text.replace(new RegExp('(^|\\s)' + pattern + '(?=\\s|$)', 'g'), ' ').replace(/\s+/g, ' ').trim();
  }

  function findFacet(text, definition) {
    var normalizedText = ' ' + normalize(text) + ' ';
    var matches = [];
    Object.keys(definition.values).forEach(function (canonical) {
      definition.values[canonical].forEach(function (alias) {
        var normalizedAlias = normalize(alias);
        if (normalizedText.indexOf(' ' + normalizedAlias + ' ') >= 0) {
          matches.push({ canonical: canonical, alias: normalizedAlias });
        }
      });
    });
    matches.sort(function (a, b) { return b.alias.length - a.alias.length; });
    return matches[0] || null;
  }

  function parseQuery(rawQuery, qualityNames) {
    var original = String(rawQuery || '').trim();
    var working = normalize(original);
    var parsed = {
      original: original, normalized: working, text: '', correctedText: '',
      correction: null, prefixCompletion: null, filters: [], facets: {}, size: null
    };
    var dimensionMatch = working.match(/(?:^|\s)(\d{2,3})\s*x\s*(\d{2,3})(?:\s|$)/);
    if (dimensionMatch) {
      parsed.size = dimensionMatch[1] + 'x' + dimensionMatch[2];
      working = replacePhrase(working, parsed.size);
    }
    Object.keys(FACETS).forEach(function (facetName) {
      var definition = FACETS[facetName];
      var match = findFacet(working, definition);
      if (!match) return;
      parsed.facets[facetName] = match.canonical;
      working = replacePhrase(working, match.alias);
    });
    var tokens = working.split(' ').filter(function (token) { return token && !STOP_WORDS[token]; });
    var correction = null;
    var correctedTokens = tokens.map(function (token, index) {
      var hit = findQualityCorrection(token, qualityNames);
      if (hit && normalize(hit.name) !== token) {
        correction = { from: token, to: hit.name, distance: hit.distance };
        return hit.name;
      }
      if (index === tokens.length - 1) {
        var prefix = findQualityPrefix(token, qualityNames);
        if (prefix) {
          parsed.prefixCompletion = prefix;
          return prefix.to;
        }
      }
      return token;
    });
    parsed.text = tokens.join(' ');
    parsed.correctedText = correctedTokens.join(' ');
    parsed.correction = correction;
    if (parsed.facets.color) parsed.filters.push({ productMetafield: { namespace: 'custom', key: FACETS.color.key, value: parsed.facets.color } });
    if (parsed.facets.room) parsed.filters.push({ productMetafield: { namespace: 'custom', key: FACETS.room.key, value: parsed.facets.room } });
    if (parsed.facets.shape) parsed.filters.push({ productMetafield: { namespace: 'custom', key: FACETS.shape.key, value: parsed.facets.shape } });
    if (parsed.size) parsed.filters.push({ variantOption: { name: 'boyut', value: parsed.size } });
    return parsed;
  }

  function addPrefixWildcard(text) {
    var tokens = String(text || '').trim().split(/\s+/).filter(Boolean);
    if (!tokens.length) return '';
    var lastIndex = tokens.length - 1;
    var last = tokens[lastIndex];
    if (normalize(last).length >= MIN_QUERY_LENGTH && !/\*$/.test(last)) tokens[lastIndex] = last + '*';
    return tokens.join(' ');
  }

  function storefrontQueryText(parsed, exact) {
    if (!exact) return normalize(parsed.original);
    var text = parsed.correctedText || parsed.text || '';
    if (!text || parsed.correction || parsed.prefixCompletion) return text;
    return addPrefixWildcard(text);
  }

  function buildSearchUrl(parsed, origin, options) {
    var base = origin || '/search';
    var settings = options || {};
    var query = settings.useOriginal ? parsed.original : (parsed.correctedText || parsed.text || '*');
    var params = new URLSearchParams();
    params.set('type', 'product');
    params.set('q', query);
    params.append('filter.p.vendor', BRAND_VENDOR);
    if (!settings.omitFilters) {
      if (parsed.facets.color) params.append('filter.p.m.custom.renk', parsed.facets.color);
      if (parsed.facets.room) params.append('filter.p.m.custom.kullan_m_alanlar_', parsed.facets.room);
      if (parsed.facets.shape) params.append('filter.p.m.custom.hal_ekli', parsed.facets.shape);
      if (parsed.size) params.append('filter.v.option.boyut', parsed.size);
    }
    return base + '?' + params.toString();
  }

  function productSearchText(product) {
    return normalize([
      product.title, (product.tags || []).join(' ')
    ].filter(Boolean).join(' '));
  }

  function productMatchesFacets(product, parsed) {
    if (product.vendor && normalize(product.vendor) !== normalize(BRAND_VENDOR)) return false;
    var haystack = ' ' + productSearchText(product) + ' ';
    var expected = [];
    if (parsed.facets.color) expected.push(normalize(parsed.facets.color));
    if (parsed.facets.room) expected.push(normalize(parsed.facets.room));
    if (parsed.facets.shape) expected.push(normalize(parsed.facets.shape));
    if (parsed.size) expected.push(normalize(parsed.size));
    return expected.every(function (term) { return haystack.indexOf(' ' + term + ' ') >= 0; });
  }

  function formatMoney(money) {
    if (!money || money.amount == null) return '';
    var amount = Number(money.amount);
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency', currency: money.currencyCode || 'TRY',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amount);
    } catch (_) {
      return amount.toFixed(2) + ' ' + (money.currencyCode || 'TRY');
    }
  }

  function createElement(document, tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  }

  function appendStaticIcon(document, target, type) {
    var span = createElement(document, 'span', 'dvss-' + type + '-icon');
    span.setAttribute('aria-hidden', 'true');
    target.appendChild(span);
  }

  function SearchController(win, form) {
    this.win = win;
    this.document = win.document;
    this.form = form;
    this.input = form.querySelector('[data-input-search], input[type="search"]');
    this.host = form.closest('hdt-predictive-search, search-form') || form;
    this.panel = null; this.list = null; this.status = null; this.footer = null;
    this.items = []; this.activeIndex = -1; this.timer = null;
    this.controller = null; this.requestSerial = 0; this.composing = false;
    this.lastResult = null; this.lastParsed = null;
    this.cache = SearchController.cache;
  }
  SearchController.cache = new Map();

  SearchController.prototype.mount = function () {
    if (!this.input || this.form.dataset.dvSmartSearchMounted === 'true') return;
    // The mobile theme component may already have attached a second predictive-search
    // listener directly to this input. Replacing it removes that duplicate request while
    // keeping every attribute and the ordinary form submission behavior.
    if (this.host.tagName === 'HDT-PREDICTIVE-SEARCH') {
      var cleanInput = this.input.cloneNode(true);
      cleanInput.value = this.input.value;
      this.input.replaceWith(cleanInput);
      this.input = cleanInput;
    }
    this.form.dataset.dvSmartSearchMounted = 'true';
    this.form.classList.add('dvss-root');
    this.host.classList.add('dvss-enhanced');
    var panelId = 'dvss-panel-' + Math.random().toString(36).slice(2, 9);
    this.panel = createElement(this.document, 'section', 'dvss-panel');
    this.panel.id = panelId; this.panel.hidden = true;
    this.panel.setAttribute('aria-label', 'Ürün arama sonuçları');
    this.status = createElement(this.document, 'div', 'dvss-status');
    this.status.setAttribute('role', 'status'); this.status.setAttribute('aria-live', 'polite');
    this.panel.appendChild(this.status);
    this.list = createElement(this.document, 'div', 'dvss-list');
    this.list.setAttribute('role', 'listbox'); this.list.id = panelId + '-list';
    this.panel.appendChild(this.list);
    this.footer = createElement(this.document, 'a', 'dvss-footer');
    this.footer.hidden = true;
    this.footer.addEventListener('mousedown', function (event) { event.preventDefault(); });
    this.panel.appendChild(this.footer);
    this.form.appendChild(this.panel);
    this.input.setAttribute('role', 'combobox');
    this.input.setAttribute('aria-autocomplete', 'list');
    this.input.setAttribute('aria-expanded', 'false');
    this.input.setAttribute('aria-controls', this.list.id);
    this.input.setAttribute('spellcheck', 'false');
    this.bindEvents();
  };

  SearchController.prototype.bindEvents = function () {
    var self = this;
    this.input.addEventListener('compositionstart', function () { self.composing = true; });
    this.input.addEventListener('compositionend', function () { self.composing = false; self.schedule(); });
    this.input.addEventListener('input', function (event) {
      event.stopPropagation();
      if (!self.composing) self.schedule();
    });
    this.input.addEventListener('focus', function () {
      if (self.input.value.trim().length >= MIN_QUERY_LENGTH) self.schedule(0);
    });
    this.input.addEventListener('keydown', function (event) { self.onKeydown(event); });
    this.form.addEventListener('submit', function (event) { self.onSubmit(event); });
    this.document.addEventListener('pointerdown', function (event) {
      if (!self.form.contains(event.target)) self.close();
    });
  };

  SearchController.prototype.schedule = function (delay) {
    var self = this;
    clearTimeout(this.timer);
    if (this.input.value.trim().length < MIN_QUERY_LENGTH) {
      this.abort(); this.close(); return;
    }
    this.timer = setTimeout(function () { self.search(); }, delay == null ? DEBOUNCE_MS : delay);
  };
  SearchController.prototype.abort = function () {
    if (this.controller) this.controller.abort();
    this.controller = null;
  };
  SearchController.prototype.open = function () {
    this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true');
  };
  SearchController.prototype.close = function () {
    if (!this.panel) return;
    this.panel.hidden = true; this.input.setAttribute('aria-expanded', 'false'); this.setActive(-1);
  };
  SearchController.prototype.setLoading = function () {
    this.open(); this.list.replaceChildren(); this.items = []; this.footer.hidden = true;
    this.status.className = 'dvss-status dvss-status--loading'; this.status.textContent = '';
    appendStaticIcon(this.document, this.status, 'spinner');
    this.status.appendChild(this.document.createTextNode(' Ürünler aranıyor…'));
  };
  SearchController.prototype.cacheGet = function (key) {
    var value = this.cache.get(key);
    if (!value || Date.now() - value.time > CACHE_TTL_MS) {
      if (value) this.cache.delete(key);
      return null;
    }
    return value.data;
  };
  SearchController.prototype.cacheSet = function (key, data) {
    if (this.cache.size >= MAX_CACHE_ENTRIES) this.cache.delete(this.cache.keys().next().value);
    this.cache.set(key, { time: Date.now(), data: data });
  };

  SearchController.prototype.fetchProducts = async function (parsed, exact) {
    var queryText = storefrontQueryText(parsed, exact);
    var brandFilter = { productVendor: BRAND_VENDOR };
    var variables = {
      query: queryText || '',
      first: exact ? RESULT_LIMIT : 24,
      filters: exact ? [brandFilter].concat(parsed.filters) : [brandFilter]
    };
    var fetcher = this.win.DV_SMART_SEARCH_FETCH || this.win.fetch.bind(this.win);
    var response = await fetcher('/api/' + API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: SEARCH_QUERY, variables: variables }),
      signal: this.controller && this.controller.signal,
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('Arama servisi HTTP ' + response.status);
    var payload = await response.json();
    if (payload.errors && payload.errors.length) throw new Error(payload.errors[0].message || 'Arama servisi hatası');
    var connection = payload.data && payload.data.search;
    if (!connection) throw new Error('Arama yanıtı eksik');
    return {
      totalCount: Number(connection.totalCount || 0),
      products: (connection.edges || []).map(function (edge) { return edge.node; }).filter(Boolean),
      fallback: !exact
    };
  };

  SearchController.prototype.enrichReviewSummaries = async function (products) {
    var handles = (products || []).map(function (product) { return product && product.handle; }).filter(Boolean);
    if (!handles.length) return products;
    var fetcher = this.win.DV_REVIEW_FETCH || this.win.fetch.bind(this.win);
    try {
      var response = await fetcher(REVIEW_API + '?handles=' + encodeURIComponent(handles.join(',')), {
        method: 'GET', headers: { Accept: 'application/json' }, signal: this.controller && this.controller.signal
      });
      if (!response.ok) return products;
      var payload = await response.json();
      var summaries = payload && payload.ok && (payload.ozetler || payload.ratings) || {};
      products.forEach(function (product) {
        if (summaries[product.handle]) product.dvReview = summaries[product.handle];
      });
    } catch (error) {
      if (error && error.name === 'AbortError') throw error;
    }
    return products;
  };

  SearchController.prototype.search = async function () {
    var raw = this.input.value.trim();
    if (raw.length < MIN_QUERY_LENGTH) return;
    var parsed = parseQuery(raw, this.win.DV_SMART_SEARCH_QUALITIES || QUALITY_NAMES);
    var key = JSON.stringify({ q: parsed.correctedText, f: parsed.filters });
    var cached = this.cacheGet(key);
    if (cached) { this.render(cached, parsed); return; }
    this.abort(); this.controller = new AbortController();
    var serial = ++this.requestSerial;
    this.setLoading();
    try {
      var result = await this.fetchProducts(parsed, true);
      if (!result.products.length && parsed.filters.length) {
        var fallback = await this.fetchProducts(parsed, false);
        fallback.products = fallback.products.filter(function (product) {
          return productMatchesFacets(product, parsed);
        }).slice(0, RESULT_LIMIT);
        fallback.totalCount = fallback.products.length;
        result = fallback;
      }
      await this.enrichReviewSummaries(result.products);
      if (serial !== this.requestSerial || raw !== this.input.value.trim()) return;
      this.cacheSet(key, result); this.render(result, parsed);
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      if (serial !== this.requestSerial) return;
      this.renderError(parsed);
    } finally {
      if (serial === this.requestSerial) this.controller = null;
    }
  };

  SearchController.prototype.render = function (result, parsed) {
    var self = this;
    this.lastResult = result; this.lastParsed = parsed;
    this.open(); this.list.replaceChildren(); this.items = []; this.activeIndex = -1;
    this.status.className = 'dvss-status';
    var chips = [];
    if (parsed.correction) chips.push('“' + parsed.correction.from + '” yerine “' + parsed.correction.to + '”');
    if (parsed.prefixCompletion) chips.push('“' + parsed.prefixCompletion.from + '” ile başlayan: “' + parsed.prefixCompletion.to + '”');
    if (parsed.facets.color) chips.push(parsed.facets.color);
    if (parsed.facets.room) chips.push(parsed.facets.room);
    if (parsed.facets.shape) chips.push(parsed.facets.shape);
    if (parsed.size) chips.push(parsed.size + ' cm');
    if (chips.length) {
      this.status.textContent = '';
      chips.forEach(function (label) { self.status.appendChild(createElement(self.document, 'span', 'dvss-chip', label)); });
    } else {
      this.status.textContent = result.totalCount ? result.totalCount + ' ürün bulundu' : '';
    }
    if (!result.products.length) {
      var empty = createElement(this.document, 'div', 'dvss-empty');
      appendStaticIcon(this.document, empty, 'empty');
      empty.appendChild(createElement(this.document, 'strong', '', 'Bu ölçütlerle ürün bulunamadı'));
      empty.appendChild(createElement(this.document, 'span', '', 'Yazımı veya filtreleri değiştirerek tekrar deneyin.'));
      this.list.appendChild(empty);
    } else {
      result.products.forEach(function (product, index) { self.renderProduct(product, index); });
    }
    this.footer.href = buildSearchUrl(parsed, '/search', result.fallback ? { useOriginal: true, omitFilters: true } : null);
    this.footer.hidden = false;
    var countLabel = result.totalCount > RESULT_LIMIT ? ' (' + result.totalCount + ')' : '';
    this.footer.textContent = result.products.length ? 'Tüm sonuçları gör' + countLabel : 'Arama sayfasında devam et';
    appendStaticIcon(this.document, this.footer, 'arrow');
  };

  SearchController.prototype.renderProduct = function (product, index) {
    var self = this;
    var link = createElement(this.document, 'a', 'dvss-product');
    link.href = '/products/' + encodeURIComponent(product.handle);
    link.setAttribute('role', 'option'); link.setAttribute('aria-selected', 'false');
    link.id = this.list.id + '-option-' + index; link.dataset.index = String(index);
    var media = createElement(this.document, 'span', 'dvss-product__media');
    if (product.featuredImage && product.featuredImage.url) {
      var image = this.document.createElement('img');
      image.src = product.featuredImage.url; image.alt = product.featuredImage.altText || product.title;
      image.width = 76; image.height = 76; image.loading = 'lazy'; image.decoding = 'async';
      media.appendChild(image);
    } else appendStaticIcon(this.document, media, 'placeholder');
    link.appendChild(media);
    var info = createElement(this.document, 'span', 'dvss-product__info');
    info.appendChild(createElement(this.document, 'span', 'dvss-product__title', product.title));
    var summary = reviewSummary(product);
    if (summary.count > 0) {
      var ratingRow = createElement(this.document, 'span', 'dv-rating dv-rating--search dvss-product__rating');
      var stars = createElement(this.document, 'span', 'dv-rating__stars');
      stars.style.setProperty('--dv-rating-fill', String(summary.rating * 20) + '%');
      stars.setAttribute('aria-hidden', 'true');
      stars.appendChild(createElement(this.document, 'span', '', '★★★★★'));
      stars.appendChild(createElement(this.document, 'b', '', '★★★★★'));
      ratingRow.appendChild(stars);
      ratingRow.appendChild(createElement(this.document, 'span', 'dv-rating__label', summary.rating.toFixed(1) + ' (' + summary.count + ')'));
      ratingRow.setAttribute('aria-label', '5 üzerinden ' + summary.rating.toFixed(1) + ' puan, ' + summary.count + ' müşteri yorumu');
      info.appendChild(ratingRow);
    }
    var priceRow = createElement(this.document, 'span', 'dvss-product__price-row');
    var current = product.priceRange && product.priceRange.minVariantPrice;
    var compare = product.compareAtPriceRange && product.compareAtPriceRange.minVariantPrice;
    priceRow.appendChild(createElement(this.document, 'strong', 'dvss-product__price', formatMoney(current)));
    if (compare && current && Number(compare.amount) > Number(current.amount)) {
      priceRow.appendChild(createElement(this.document, 's', 'dvss-product__compare', formatMoney(compare)));
    }
    info.appendChild(priceRow);
    info.appendChild(createElement(
      this.document, 'span',
      'dvss-product__stock ' + (product.availableForSale ? 'is-available' : 'is-unavailable'),
      product.availableForSale ? 'Satışa hazır' : 'Tükendi'
    ));
    link.appendChild(info);
    link.addEventListener('pointerenter', function () { self.setActive(index); });
    link.addEventListener('focus', function () { self.setActive(index); });
    this.list.appendChild(link); this.items.push(link);
  };

  SearchController.prototype.renderError = function (parsed) {
    this.lastResult = null; this.lastParsed = parsed;
    this.open(); this.list.replaceChildren(); this.items = [];
    this.status.className = 'dvss-status dvss-status--error';
    this.status.textContent = 'Hızlı sonuçlar şu an yüklenemedi.';
    this.footer.href = buildSearchUrl(parsed, '/search', { useOriginal: true, omitFilters: true });
    this.footer.textContent = 'Arama sayfasında devam et';
    appendStaticIcon(this.document, this.footer, 'arrow'); this.footer.hidden = false;
  };
  SearchController.prototype.setActive = function (index) {
    this.activeIndex = index;
    this.items.forEach(function (item, itemIndex) {
      item.setAttribute('aria-selected', itemIndex === index ? 'true' : 'false');
    });
    if (index >= 0 && this.items[index]) this.input.setAttribute('aria-activedescendant', this.items[index].id);
    else this.input.removeAttribute('aria-activedescendant');
  };
  SearchController.prototype.onKeydown = function (event) {
    if (event.key === 'Escape') { this.close(); return; }
    if (this.panel.hidden || !this.items.length) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault(); this.setActive((this.activeIndex + 1) % this.items.length);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault(); this.setActive((this.activeIndex - 1 + this.items.length) % this.items.length);
    } else if (event.key === 'Enter' && this.activeIndex >= 0) {
      event.preventDefault(); this.items[this.activeIndex].click();
    }
  };
  SearchController.prototype.onSubmit = function (event) {
    var raw = this.input.value.trim();
    if (!raw) return;
    if (this.activeIndex >= 0 && this.items[this.activeIndex]) {
      event.preventDefault(); this.items[this.activeIndex].click(); return;
    }
    var parsed = parseQuery(raw, this.win.DV_SMART_SEARCH_QUALITIES || QUALITY_NAMES);
    var sameRenderedQuery = this.lastParsed && this.lastParsed.original === parsed.original && this.lastResult;
    if (parsed.correction || (parsed.filters.length && sameRenderedQuery)) {
      event.preventDefault();
      var fallbackOptions = sameRenderedQuery && this.lastResult.fallback
        ? { useOriginal: true, omitFilters: true }
        : null;
      this.win.location.assign(buildSearchUrl(parsed, '/search', fallbackOptions));
    }
  };

  function enhance(root) {
    root.document.querySelectorAll('form[data-frm-search]').forEach(function (form) {
      if (!form.querySelector('[data-input-search], input[type="search"]')) return;
      new SearchController(root, form).mount();
    });
  }
  function boot(root) {
    function start() {
      enhance(root);
      var observer = new MutationObserver(function (mutations) {
        if (mutations.some(function (mutation) { return mutation.addedNodes.length > 0; })) enhance(root);
      });
      observer.observe(root.document.documentElement, { childList: true, subtree: true });
      root.document.addEventListener('shopify:section:load', function () { enhance(root); });
    }
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }

  return {
    normalize: normalize, levenshtein: levenshtein,
    findQualityCorrection: findQualityCorrection, findQualityPrefix: findQualityPrefix,
    parseQuery: parseQuery, buildSearchUrl: buildSearchUrl,
    storefrontQueryText: storefrontQueryText,
    productMatchesFacets: productMatchesFacets, formatMoney: formatMoney, reviewSummary: reviewSummary,
    SearchController: SearchController, enhance: enhance, boot: boot,
    constants: {
      API_VERSION: API_VERSION, RESULT_LIMIT: RESULT_LIMIT, MIN_QUERY_LENGTH: MIN_QUERY_LENGTH,
      QUALITY_NAMES: QUALITY_NAMES, FACETS: FACETS, SEARCH_QUERY: SEARCH_QUERY,
      BRAND_VENDOR: BRAND_VENDOR, REVIEW_API: REVIEW_API
    }
  };
});
